export default "__VITE_ASSET__5b89f862__"